<template>
  <div class="pa-3">
    <div style="margin-left:30%;max-width:600px" v-if="step === 1">
      <v-card>
        <v-card-text class="bg-white" style="margin-top:20px;">
          <v-container class="coverage-form-container" style="max-width:1200px">
            <v-row>
              <v-col class="d-flex flex-row pt-0" cols="12">
                <p class="h4 mb-2 pt-3 label-left">Choose Platform <span class="red--text">*</span></p>
                <v-select
                  style="max-width:200px;margin-top:10px"
                  outlined
                  hide-details
                  dense
                  :items="platformList"
                  v-model="platform"
                  @change="paginate()"
                  required
                  :error-messages="$v.platform.$error && `Platform is required.`"
                  @input="$v.platform.$touch()"
                ></v-select>
              </v-col>
              <v-col class="d-flex flex-row pt-0" cols="12">
                <p class="h4 mb-2 pt-3 label-left">Inf. Country <span class="red--text">*</span></p>
                <!-- <v-select
                  style="max-width:200px;margin-top:10px"
                  class="pr-1"
                  :items="countries"
                  hide-details
                  outlined
                  dense
                  v-model="searchSettings.influencerGeos"
                  required
                  :error-messages="$v.searchSettings.country.$error && `Country is required.`"
                  @input="$v.searchSettings.country.$touch()"
                >
                </v-select> -->
                <v-autocomplete
                  style="max-width:200px;margin-top:10px"
                  v-model="searchSettings.influencerGeos"
                  :items="countries"
                  dense
                  hide-selected
                  clearable
                  small-chips
                  outlined
                  hide-details="auto"
                  label=""
                  multiple
                  required
                  :error-messages="$v.searchSettings.influencerGeos.$error && `Country is required.`"
                  @input="$v.searchSettings.influencerGeos.$touch()"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex flex-row pt-0" cols="12">
                <p class="h4 mb-2 pt-3 label-left">Aud. Country <span class="red--text">*</span></p>
                <!-- <v-select
                  style="max-width:200px;margin-top:10px"
                  class="pr-1"
                  :items="countries"
                  hide-details
                  outlined
                  dense
                  v-model="searchSettings.influencerGeos"
                  required
                  :error-messages="$v.searchSettings.country.$error && `Country is required.`"
                  @input="$v.searchSettings.country.$touch()"
                >
                </v-select> -->
                <v-autocomplete
                  style="max-width:200px;margin-top:10px"
                  v-model="searchSettings.audGeos"
                  :items="countries"
                  dense
                  hide-selected
                  clearable
                  small-chips
                  outlined
                  hide-details="auto"
                  label=""
                  multiple
                  required
                  :error-messages="$v.searchSettings.audGeos.$error && `Country is required.`"
                  @input="$v.searchSettings.audGeos.$touch()"
                >
                </v-autocomplete>
                <v-autocomplete
                  outlined
                  dense      
                  hide-details="auto"
                  :items="searchConfig.percentOptions"
                  v-model="searchSettings.audGeoPercent"
                  style="max-width:90px;margin-top:10px"
                ></v-autocomplete>
              </v-col>
              <v-col class="d-flex flex-row pt-0" cols="12">
                <p class="h4 mb-2 pt-3 label-left">Followers <span class="red--text">*</span></p>
                <v-list min-height="100px">
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col class="pl-0" cols="12" xs="12" md="6" lg="6">
                        From
                        <v-combobox
                          outlined
                          dense      
                          hide-details="auto"
                          :items="searchConfig.followerOptions.from"
                          v-model="searchSettings.followers.from"
                          style="max-width:120px;" 
                        ></v-combobox>
                      </v-col>
                      <v-col class="pl-0" cols="12" xs="12" md="6" lg="6">
                        To
                        <v-combobox
                          outlined
                          dense        
                          hide-details="auto"
                          :items="searchConfig.followerOptions.to"
                          v-model="searchSettings.followers.to"
                          style="max-width:120px;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col class="d-flex flex-row pt-0" cols="12">
                <p class="h4 mb-2 pt-3 label-left">Gender <span class="red--text">*</span></p>
                <v-radio-group class="mt-0" v-model="searchSettings.infGender">
                  <v-radio label="Male or Female" value="KNOWN"></v-radio>
                  <v-radio label="Male" value="MALE"></v-radio>
                  <v-radio label="Female" value="FEMALE"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5 mb-5 justify-end">
          <v-btn
            style="min-width:120px"
            color="success"
            @click="changeNext()"
          >
            <v-icon v-on="on">mdi-skip-next</v-icon> Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div v-if="step === 2">
      <v-row>
        <v-col cols="12" align="center">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row" style="justify-content:center;">
                <div class="d-flex flex-column">
                  <div class="d-flex flex-row pt-2">
                    <div class="pr-2">
                      <!-- <p class="body-2 font-weight-bold">Bio</p> -->
                      <v-text-field
                        class="min-max-200"
                        v-model="searchSettings.bio"
                        @keyup.enter="searchInf()"
                        label="Bio"
                        outlined
                        dense        
                        clearable
                        hide-details="auto"
                      />
                    </div>
                    <div class="pr-2">
                      <!-- <p class="body-2 font-weight-bold">Keywords</p> -->
                      <v-text-field
                        class="min-max-200"
                        v-model="searchSettings.keywords"
                        @keyup.enter="searchInf()"
                        label="Keywords"
                        outlined
                        dense        
                        clearable
                        hide-details="auto"
                      />
                    </div>
                  </div>
                  <div class="d-flex flex-row pt-2">
                    <div class="pr-2">
                      <!-- <p class="body-2 font-weight-bold">Mentions</p> -->
                      <v-combobox
                        class="min-max-200"
                        v-model="searchSettings.mentions"
                        @change="searchInf()"
                        label="Mentions"
                        outlined
                        dense        
                        chips
                        clearable
                        multiple
                        hide-details="auto"
                      >
                        <template v-slot:selection="{ attrs, item, parent, selected }">
                          <v-chip
                            v-if="item === String(item)"
                            v-bind="attrs"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon
                              small
                              @click="parent.selectItem(item)"
                            >
                              $delete
                            </v-icon>
                          </v-chip>
                          <v-chip
                            v-if="item === Object(item)"
                            v-bind="attrs"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item.name }}
                            </span>
                            <v-icon
                              small
                              @click="parent.selectItem(item)"
                            >
                              $delete
                            </v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                    <div class="pr-2">
                      <!-- <p class="body-2 font-weight-bold">Hashtags</p> -->
                      <v-combobox
                        class="min-max-200"
                        v-model="searchSettings.hashtags"
                        @change="searchInf()"
                        label="Hashtags"
                        outlined
                        dense        
                        chips
                        clearable
                        multiple
                        hide-details="auto"
                      >
                        <template v-slot:selection="{ attrs, item, parent, selected }">
                          <v-chip
                            v-if="item === String(item)"
                            v-bind="attrs"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon
                              small
                              @click="parent.selectItem(item)"
                            >
                              $delete
                            </v-icon>
                          </v-chip>
                          <v-chip
                            v-if="item === Object(item)"
                            v-bind="attrs"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item.name }}
                            </span>
                            <v-icon
                              small
                              @click="parent.selectItem(item)"
                            >
                              $delete
                            </v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                  </div>
                  <div class="d-flex flex-row pt-2">
                    <div class="pr-2">
                      <v-autocomplete
                        class="search-keyword min-max-200"
                        v-model="audLookKeyword"
                        :items="audLookItems"
                        :loading="audLookLoading"
                        outlined
                        hide-details
                        chips
                        dense
                        label="Aud. Lookalikes"
                        :search-input.sync="newAudLookKeyword"
                        @keyup="searchAudLookalike"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            close
                            @click:close="removeAudLookKeyword()"
                            class="v-chip--select-multi"
                          >{{ data.item }}</v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content>
                              <v-list-item-title>@{{data.item}}</v-list-item-title>
                              <v-list-item-subtitle></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div class="pr-2">
                      <v-autocomplete
                        class="search-keyword min-max-200"
                        v-model="infLookKeyword"
                        :items="infLookItems"
                        :loading="lookLoading"
                        outlined
                        hide-details
                        chips
                        dense
                        label="Inf. Lookalikes"
                        :search-input.sync="newInfLookKeyword"
                        @keyup="searchInfLookalike"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            close
                            @click:close="removeLookKeyword()"
                            class="v-chip--select-multi"
                          >{{ data.item }}</v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content>
                              <v-list-item-title>@{{data.item}}</v-list-item-title>
                              <v-list-item-subtitle></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="pr-2 pt-2">
                    <v-autocomplete
                      class="search-keyword min-max-250"
                      v-model="keyword"
                      :items="searchItems"
                      item-text="tag"
                      :loading="keywordLoading"
                      multiple
                      outlined
                      hide-details
                      chips
                      dense
                      label="Search by Topic"
                      :search-input.sync="newKeyword"
                      @keyup="searchByKeywords"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                          close
                          @click:close="removeKeyword(data.item)"
                          class="v-chip--select-multi"
                        >{{ data.item.tag }}</v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>{{data.item.tag}}</v-list-item-title>
                            <v-list-item-subtitle></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                  <v-select
                    style="padding-top:30px"
                    class="topic-platform-select min-max-250 pt-2"
                    outlined
                    dense        
                    hide-details
                    :items="platformList"
                    v-model="platform"
                    @change="paginate()"
                  ></v-select>
                  <div class="text-right pt-2">
                    <v-btn color="success" @click="searchInf">Search</v-btn>
                  </div>
                </div>
                <v-btn class="pt-2" icon @click="openSettingsDialog">
                  <v-icon color="red lighten-2" dark>settings</v-icon>
                </v-btn>
              </div>
            </div>
            <settings-modal
              :value="dialog"
              :oldSettings="searchSettings"
              v-model="dialog"
              @saveSettings="saveSettings"
            />
        </v-col>
        <!-- <v-col cols="12">
        </v-col> -->
      </v-row>
      <div class="text-center mt-3 mb-3" style="width:100%;" v-if="wordCloudData.length">
        <div>
          <vue-word-cloud
            style="position: relative;max-width:700px;height:200px;margin-left:25%"
            :v-show="true"
            :words="wordCloudData"
            :color="([,]) => getRandomColor()"
            :animation-duration="1"
            :font-size-ratio="2"
            :spacing="0.5"
            font-family="Roboto"
          />
        </div>
      </div>
      
      <!-- IQData Data Table -->
      <div class="row mt-3">
        <div class="col-xs-12">
          <div class="col-sm-6 pb-0" style="margin-top: 25px;">
            <strong>Total Influencers: {{totalItems | thousandSeprator}}</strong>
          </div>
          <div class="col-sm-6">
            <v-text-field
              class="float-right mb-2"
              style="min-width:500px;max-width:500px"
              v-model="iqDataTableSearch"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </div>
        </div>
        <div class="col-xs-12">
          <v-col class="pt-0" cols="12" xs="12" md="12">
            <v-btn color="warning" @click="exportExcel" small>
              <v-icon left>mdi-file-excel</v-icon>Export
            </v-btn>
          </v-col>
        </div>
        <div class="col-xs-12">
          <v-data-table
            :headers="iqDataHeaders"
            :items="iqDataItems"
            :items-per-page="20"
            :page="currentPage"
            item-key="handle"
            :loading="loading"
            :search="iqDataTableSearch"
            :footer-props="{
              itemsPerPageOptions: rowsPerPageItems
            }"
            no-data-text="Empty list"
          >
            <template v-slot:body="{items}">
              <tbody v-if="items.length">
                <tr v-for="item in items" :key="item.handle">
                  <td class="text-xs-left" style="min-width:200px">
                    <v-avatar :size="avatarSize" color="grey lighten-4">
                      <img v-bind:src="item.profilePicture" alt="avatar" />
                    </v-avatar>
                    <v-tooltip bottom v-if="item.hidden">
                      <template v-slot:activator="{ on }">
                        <span class="hidden-text" v-on="on">Hidden</span>
                      </template>
                      <span>Hidden</span>
                    </v-tooltip>
                    <social-handle
                      divClassName="d-inline"
                      :isTikTok="platformShort === 'tiktok'"
                      :isInstagram="platformShort === 'instagram'"
                      :isYoutube="platformShort === 'youtube'"
                      :tiktokHandle="item.handle"
                      :instagramHandle="item.handle"
                      :youtubeHandle="item.handle"
                      v-else
                    />
                  </td>
                  <td class="text-xs-left">{{ item.fullName }}</td>
                  <td class="text-xs-left">{{ item.totalFollowers | thousandSeprator}}</td>
                  <td class="text-xs-left">{{ item.engagementRate }}%</td>
                  <td class="text-xs-left">{{ item.engagements | thousandSeprator}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <div class="pa-3">Empty List</div>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </div>
      <div class="text-center pt-3">
        <v-btn color="warning" style="min-width: 101px;" @click="searchNextInf">
          <v-icon>mdi-skip-next</v-icon> More
        </v-btn>
      </div>
      <v-row v-if="isSuperAdminRole">
        <v-col class="d-flex flex-row" style="justify-content:center;">
          <!-- <span class="lbl-kobe">Global</span> -->
          <!-- <v-switch
            class="pr-5"
            v-model="isLocal"
            label="Search in Audience Details"
            color="secondary"
            :value="false"
            hide-details
            @change="changeIQDataSwitch()"
          ></v-switch> -->
        </v-col>
      </v-row>
      <!-- Local IMS Data Table -->
      <div class="row" v-if="isLocal">
        <div class="col-xs-12">
          <div class="mt-3">
            <v-data-table
              :headers="fields"
              :items="items"
              :options.sync="localPagination"
              :footer-props="{
                itemsPerPageOptions: rowsPerPageItems
              }"
              :server-items-length="localTotalItems"
              item-key="handle"
              :loading="localLoading"
              :no-data-text="'Empty list'"
            >
              <template v-slot:body="{items}">
                <tbody v-if="items.length">
                  <tr v-for="item in items" :key="item.handle">
                    <td class="text-xs-left" style="min-width:200px">
                      <v-avatar :size="avatarSize" color="grey lighten-4">
                        <img v-bind:src="item.profilePicture" alt="avatar" />
                      </v-avatar>
                      <social-handle
                        divClassName="d-inline"
                        :isTikTok="platformShort === 'tiktok'"
                        :isInstagram="platformShort === 'instagram'"
                        :isYoutube="platformShort === 'youtube'"
                        :tiktokHandle="item.handle"
                        :instagramHandle="item.handle"
                        :youtubeHandle="item.handle"
                      />
                      <v-btn
                        class="btn-reload pl-0"
                        text
                        x-small
                        color="warning"
                        @click="refreshReport(item)"
                      >
                        <v-icon dark small>
                          mdi-reload
                        </v-icon>
                      </v-btn>
                    </td>
                    <td class="text-xs-left">{{ item.fullName }}</td>
                    <td class="text-xs-left">
                      <v-chip
                        class="mr-1"
                        label
                        color="green"
                        small
                        text-color="white"
                        v-if="item.tags && item.tags.length > 0"
                      >
                        <v-icon float-left small>label</v-icon>&nbsp;
                        {{item.tags[0]}}
                      </v-chip>
                      <v-menu                                                            
                      v-show="item.infInterests"      
                      :close-on-content-click="false"    
                      top                                                 
                      offset-x                              
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :id="'btnMore_'+item.id"
                            v-show="item.tags && item.tags.length > 1"
                            color="primary"
                            x-small
                            dark
                            v-bind="attrs"
                            v-on="on"
                            text
                          >
                            More...
                          </v-btn>
                        </template>
                        <v-card max-width="300" style="text-align: left;">
                          <v-card-text>
                            <b>Tags</b>
                            <v-divider></v-divider>                                    
                            <v-chip                                      
                              v-for="(tag, index) in item.tags"
                              :key="index"
                              v-show="index !== 0"
                              class="ma-2"
                              label
                              color="green"
                              small
                              text-color="white"
                            >
                            <v-icon float-left small>label</v-icon>&nbsp;
                            {{tag}}
                            </v-chip>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </td>
                    <td class="text-xs-left">{{ item.totalFollowers | thousandSeprator}}</td>
                    <td class="text-xs-left">{{ item.engagementRate }}%</td>
                    <td class="text-xs-left">{{ item.avgViews | thousandSeprator}}</td>
                    <td class="text-xs-left">{{ item.avgLikes | thousandSeprator}}</td>
                    <td class="text-xs-left">{{ item.avgComments | thousandSeprator}}</td>
                    <td class="text-xs-left">{{ item.avgReelPlays | thousandSeprator}}</td>
                    <td class="justify-center layout px-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            medium
                            class="mr-2"
                            v-on="on"
                            color="success"
                            @click.stop="showReport(item)"
                          >assessment</v-icon>
                        </template>
                        <span>View Audience Data</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            medium
                            class="mr-2"
                            v-on="on"
                            color="success"
                            @click.stop="viewInfluencerPosts(item)"
                          >local_library</v-icon>
                        </template>
                        <span>View Top Posts</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            medium
                            class="mr-2"
                            v-on="on"
                            color="success"
                            @click.stop="viewRecentPosts(item)"
                          >mdi-file-clock-outline</v-icon>
                        </template>
                        <span>View Recent Posts</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            medium
                            class="mr-2"
                            v-on="on"
                            color="success"
                            @click.stop="viewSimilarUsers(item)"
                          >mdi-account-group</v-icon>
                        </template>
                        <span>View Lookalikes</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <div class="pa-3">Empty List</div>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
      <!-- End of Local IMS Data Table -->
    </div>
    <!-- End of IQData Data Table -->
    <!-- Audience data report modal -->
    <audience-data-report-modal
      v-model="viewAudienceDataDialog"
      :audienceData="audienceDataReport"
    />

    <!-- loading -->
    <!-- <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <!-- View Influencer post -->
    <influencer-post-modal
      :modalId="influencerPostModalId"
      :title="postsTitle"
      :platform="platformShort"
      :shortCodes="shortCodes"
    />
    <!-- View similar users post -->
    <similar-users-modal
      v-model="viewSimilarUsersDialog"
      :handle="similarHandle"
      :items="similarItems"
      :platform="platformShort"
    />
    <button
      id="viewReport"
      style="display: none"
      data-toggle="modal"
      :data-target="audienceDataReportDisplay"
    ></button>
    <button
      id="viewPosts"
      style="display: none"
      data-toggle="modal"
      :data-target="influencerPostDisplay"
    ></button>
    <loading
      :active.sync="overlayLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
// import moment from 'moment';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import config from '@/config';
import searchConfig from './config';
// import utils from '@/utils';
import influencerAPIs from '../influencerAPIs';
import AudienceDataReportModal from '../AudienceDataReportModal';
import InfluencerPostModal from '../InfluencerPostsModal';
import SimilarUsersModal from './SimilarUsersModal';
import SettingsModal from './SettingsModal';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import VueWordCloud from 'vuewordcloud';
import sortBy from 'lodash/sortBy';
import campaignHelper from '../../Campaign/campaignHelper';
import countries from '../../../../../static/sources/countries';
import Loading from 'vue-loading-overlay';
export default {
  name: 'SearchKeyword',
  mixins: [validationMixin],
  validations: function() {
    const validationRules = {
      searchSettings: {
        influencerGeos: {
          required
        },
        audGeos: {
          required
        },
        infGender: {
          required
        }
      },
      platform: {
        required
      }
    };
    // this.formConfig.sections.forEach(field => {
    //   if (field.fields) {
    //     field.fields.forEach(sectionField => {
    //       if (!sectionField.multiple) {
    //         validationRules['rateCardData'][sectionField.name] = sectionField.required ? {required} : '';
    //       }
    //     })
    //   }
    // })
    return validationRules
  },
  components: {
    AudienceDataReportModal,
    InfluencerPostModal,
    SimilarUsersModal,
    SettingsModal,
    SocialHandle,
    [VueWordCloud.name]: VueWordCloud,
    Loading
  },
  data() {
    return {
      audienceDataReportId: 'audience_data_report_modal',
      influencerPostModalId: 'influencerPostModalId',
      viewAudienceDataDialog: false,
      viewInfluencerData: null,
      audienceDataReport: null,
      expand: false, // Close other rows
      loading: false,
      keywordLoading: false,
      peformSearch: 'none',
      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [''],
        itemsPerPage: 20
      },
      localPagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [''],
        itemsPerPage: 20
      },
      totalItems: 0,
      localTotalItems: 0,
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      originalItems: [],
      postsTitle: '',
      avatarSize: 35, // avatar
      shortCodes: [],
      searchConfig,
      fields: searchConfig.localTableHeaders,
      countries: [],
      items: [],
      totalRows: 0,
      currentPage: 1,
      localCurrentPage: 1,
      perPage: 20,
      searchedItems: [],
      searchItems: [],
      resultMessage: '',
      keyword: [],
      multipleKeywords: [],
      wordCloudData: [],
      platformList: ['Instagram', 'TikTok', 'Youtube'],
      platform: 'Instagram',
      overlayLoading: false,
      dialog: false,
      searchSettings: searchConfig.searchSettings,
      viewSimilarUsersDialog: false,
      similarHandle: '',
      similarItems: [],
      // IQData Table Attributes
      iqDataHeaders: searchConfig.iqDataTableHeaders,
      iqDataItems: [],
      isIqData: true,
      isMainSearch: false,
      isLocal: false,
      iqDataTotal: 0,
      iqDataTableSearch: '',
      step: 1,
      // aud lookalikes
      newAudLookKeyword: '',
      audLookKeyword: '',
      audLookItems: [],
      audLookLoading: false,
      // inf lookalikes
      newInfLookKeyword: '',
      infLookKeyword: '',
      infLookItems: [],
      lookLoading: false
    };
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isSuperAdminRole: function () {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    audienceDataReportDisplay: function() {
      return '#' + this.audienceDataReportId;
    },
    influencerPostDisplay: function() {
      return '#' + this.influencerPostModalId;
    },
    platformShort: function() {
      return this.platform.toLowerCase()
    },
    localPayload() {
      let perPage = this.localPagination.itemsPerPage <= 0 ? 20 : this.localPagination.itemsPerPage
      let distance = 0
      let freq = 0
      if (this.searchSettings.distance) {
        distance = (this.searchSettings.distance / 100).toFixed(2)
      }
      if (this.searchSettings.frequency) {
        freq = (this.searchSettings.frequency / 10).toFixed(2)
      }
      let topicKeyword = Object.assign([], this.keyword)
      if (this.multipleKeywords.length) {
        // if mutiple keywords, set multiple keywords
        topicKeyword = Object.assign([], this.multipleKeywords)
      }
      return {
        filter: {
          platform: this.platformShort,
          tags: topicKeyword,
          relevancy: (this.searchSettings.relevantKeywords / 100).toFixed(2),
          distance,
          freq,
          influencerGeos: this.searchSettings.influencerGeos,
          audGeos: this.searchSettings.audGeos,
          audGeoPercent: Number(this.searchSettings.audGeoPercent.replace('≥', '').replace('%', '')) / 100,
          infGender: this.searchSettings.infGender,
          audGender: this.searchSettings.audGender,
          audGenderPercent: Number(this.searchSettings.audGenderPercent.replace('≥', '').replace('%', '')) / 100,
          followers: this.searchSettings.followers,
          engagements: this.searchSettings.engagements,
          engagementRate: this.searchSettings.engagementRate,
          bio: this.searchSettings.bio,
          keywords: this.searchSettings.keywords,
          mentions: this.searchSettings.mentions,
          hashtags: this.searchSettings.hashtags,
          audLookalike: this.audLookKeyword || '',
          infLookalike: this.infLookKeyword || '',
          isIqData: false
        },
        paging: {
          per_page: perPage,
          page: 1,
          sortBy: this.localPagination.sortBy[0],
          descending: this.localPagination.sortDesc[0]
        }
      }
    }
  },
  watch: {
    pagination(newVal) {
      // if (this.keyword.length) {
      //   this.paginate(newVal.page);
      // }
      this.paginate(newVal.page);
    },
    localPagination(newVal) {
      // if (this.keyword.length) {
      //   this.localPaginate(newVal.page);
      // }
      // this.localPaginate(newVal.page);
    },
    keyword(newVal) {
      this.refreshWordCloud()
    }
  },
  methods: {
    async searchInf() {
      this.isMainSearch = true
      this.isIqData = true
      this.paginate()
      // this.localPaginate()
    },
    payload(page) {
      let perPage = this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage
      let distance = 0
      let freq = 0
      if (this.isIqData) {
        // for IQData Search, force results to 10 only
        perPage = 20
      }
      if (this.searchSettings.distance) {
        distance = (this.searchSettings.distance / 100).toFixed(2)
      }
      if (this.searchSettings.frequency) {
        freq = (this.searchSettings.frequency / 10).toFixed(2)
      }
      let topicKeyword = Object.assign([], this.keyword)
      if (this.multipleKeywords.length) {
        // if mutiple keywords, set multiple keywords
        topicKeyword = Object.assign([], this.multipleKeywords)
      }
      return {
        filter: {
          platform: this.platformShort,
          tags: topicKeyword,
          relevancy: (this.searchSettings.relevantKeywords / 100).toFixed(2),
          distance,
          freq,
          influencerGeos: this.searchSettings.influencerGeos,
          audGeos: this.searchSettings.audGeos,
          audGeoPercent: Number(this.searchSettings.audGeoPercent.replace('≥', '').replace('%', '')) / 100,
          infGender: this.searchSettings.infGender,
          audGender: this.searchSettings.audGender,
          audGenderPercent: Number(this.searchSettings.audGenderPercent.replace('≥', '').replace('%', '')) / 100,
          followers: this.searchSettings.followers,
          engagements: this.searchSettings.engagements,
          engagementRate: this.searchSettings.engagementRate,
          bio: this.searchSettings.bio,
          keywords: this.searchSettings.keywords,
          mentions: this.searchSettings.mentions,
          hashtags: this.searchSettings.hashtags,
          audLookalike: this.audLookKeyword || '',
          infLookalike: this.infLookKeyword || '',
          isIqData: this.isIqData
        },
        paging: {
          per_page: perPage,
          page,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      }
    },
    async paginate(page = 1) {
      if (this.isIqData) {
        if (this.iqDataTotal) {
          // check if remain inf for iqData Search
          let isContinue = await this.checkRemainInf()
          if (!isContinue) return
        }
      }
      // proceed to search
      // if (!this.keyword.length) {
      //   // no keywords in search, return
      //   this.items = []
      //   return
      // }
      this.setRouteParams()
      // this.payload.paging.page = page;
      this.loading = true;
      influencerAPIs
        .searchAudDataKeyword(this.payload(page))
        .then(response => {
          this.loading = false
          // if iqdata social data
          if (this.isMainSearch) {
          // if search from button or settings, clear table data
            this.iqDataItems = []
            this.isMainSearch = false
          }
          this.updateIqDataItems(response.influencers)
          this.iqDataTotal += response.influencers.length
          this.totalItems = response.totalInfluencers;
          if (this.pagination.itemsPerPage === -1) {
            this.pagination.itemsPerPage = 20;
          }
          this.currentPage = page;
        })
        .catch(error => {
          this.loading = false
          console.log(error);
        });
    },
    async localPaginate(page = 1) {
      if (this.isIqData) {
        if (this.iqDataTotal) {
          // check if remain inf for iqData Search
          let isContinue = await this.checkRemainInf()
          if (!isContinue) return
        }
      }
      // proceed to search
      // if (!this.keyword.length) {
      //   // no keywords in search, return
      //   this.items = []
      //   return
      // }
      this.setRouteParams()
      this.localPayload.paging.page = page;
      this.localLoading = true;
      influencerAPIs
        .searchAudDataKeyword(this.localPayload)
        .then(response => {
          this.localLoading = false
          // If from IMS local data
          this.updateItems(response.influencers);
          this.localTotalItems = response.totalInfluencers;
          if (this.localPagination.itemsPerPage === -1) {
            this.localPagination.itemsPerPage = 20;
          }
          this.localCurrentPage = page;
        })
        .catch(error => {
          this.localLoading = false
          console.log(error);
        });
    },
    updateItems(response) {
      const displayItems = response.map(element => {
        // assign tags for display in data table.
        let tags = []
        if (element.user_profile) {
          if (element.user_profile.relevant_tags) {
            let matchTags = element.user_profile.relevant_tags.filter(rt => this.keyword.includes(rt.tag) || this.multipleKeywords.includes(rt.tag))
            if (matchTags) {
              tags = matchTags.map(m => m.tag)
            }
          }
        }
        // structure data
        let resp = {
          id: element.id,
          reportID: element.report_info.report_id,
          handle: element.user_profile ? (element.user_profile.username || element.user_profile.custom_name) : '',
          fullName: element.user_profile ? element.user_profile.fullname : '',
          totalFollowers: element.user_profile ? element.user_profile.followers : '',
          profilePicture: element.user_profile
              ? element.user_profile.picture || '/static/img/avatar/user.png'
              : '/static/img/avatar/user.png',
          engagementRate: element.user_profile
              ? (Number(element.user_profile.engagement_rate) * 100).toFixed(2)
              : 0,
          avgViews: element.user_profile.avg_views || '',
          avgLikes: element.user_profile.avg_likes || '',
          avgComments: element.user_profile.avg_comments || '',
          avgReelPlays: element.user_profile.avg_reels_plays || '',
          tags,
          top_posts: element.user_profile.top_posts,
          recent_posts: element.user_profile.recent_posts,
          similarUsers: element.user_profile.similar_users || [],
          countryName: ''
        }
        return resp
      });
      this.items = displayItems;
      this.totalRows = response.totalInfluencers;
      this.setProfilePics()
    },
    updateIqDataItems(response) {
      response.map(element => {
        // structure data
        let userProfile = null
        if (element.account) {
          userProfile = element.account.user_profile
        }
        let resp = {
          handle: userProfile ? (userProfile.username || userProfile.custom_name) : '',
          fullName: userProfile ? userProfile.fullname : '',
          totalFollowers: userProfile ? userProfile.followers : '',
          profilePicture: userProfile
              ? userProfile.picture || '/static/img/avatar/user.png'
              : '/static/img/avatar/user.png',
          engagementRate: userProfile
              ? (Number(userProfile.engagement_rate) * 100).toFixed(2)
              : '',
          engagements: userProfile
              ? (Number(userProfile.engagements) * 100).toFixed(2)
              : ''
        }
        if (typeof resp.handle === 'undefined') {
          resp.hidden = true
        }
        this.iqDataItems.push(resp)
        return resp
      });
    },
    viewInfluencerPosts(item) {
      let posts = item.top_posts || [];
      if (posts.length > 0) {
        posts = this.getPostShortCode(posts)
        posts = posts.filter(p => p.shortCode)
        this.shortCodes = posts.map(item => item.shortCode);
        document.getElementById('viewPosts').click();
        this.postsTitle = `Related Posts (${item.handle})`;
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    viewRecentPosts(item) {
      let posts = item.recent_posts || [];
      if (posts.length > 0) {
        posts = this.getPostShortCode(posts)
        posts = posts.filter(p => p.shortCode)
        this.shortCodes = posts.map(item => item.shortCode);
        document.getElementById('viewPosts').click();
        this.postsTitle = `Recent Posts(${item.handle})`;
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    getPostShortCode(posts) {
      posts = posts.map(p => {
        let matches;
        if (this.platformShort === 'instagram') {
          if ((matches = p.link.match(config.regexPattern.instagram_post)) !== null) {
            p.shortCode = matches[1];
          }
        } else if (this.platformShort === 'tiktok') {
          if ((matches = p.link.match(config.regexPattern.TIKTOK_POST)) !== null) {
            p.shortCode = matches[1];
            if (p.shortCode) {
              p.shortCode = campaignHelper.getTikTokPost(p.shortCode)
            }
          }
        } else if (this.platformShort === 'youtube') {
          if ((matches = p.link.match(config.regexPattern.YOUTUBE_POST)) !== null) {
            p.shortCode = matches[1];
            if (p.shortCode) {
              p.shortCode = campaignHelper.getYoutubePost(p.shortCode)
            }
          }
        }
        return p
      })
      return posts
    },
    viewSimilarUsers(item) {
      this.similarItems = Object.assign([], item.similarUsers)
      if (this.similarItems) {
        this.similarItems = this.similarItems.map(element => {
          if (element.geo) {
            if (element.geo.country.name) {
              element.countryName = element.geo.country.name
            }
          }
          return element
        })
      }
      this.similarHandle = item.handle
      this.viewSimilarUsersDialog = true
    },
    showReport(influencer) {
      this.overlayLoading = true;
      influencerAPIs
        .fetchLocalAudienceReport(influencer.id, null, influencer.handle, 'instagram')
        .then(resp => {
          this.audienceDataReport = resp.data;
          // document.getElementById('viewReport').click();
          this.viewAudienceDataDialog = true;
          this.overlayLoading = false;
        })
        .catch(err => {
          console.error(err);
          this.overlayLoading = false;
        });
    },
    searchByKeywords() {
      if (!this.newKeyword || this.newKeyword === null) {
        return
      }
      if (this.newKeyword.length < 2) {
        return
      }
      setTimeout(() => {
        this.keywordLoading = true
        influencerAPIs
        .searchTopicKeyword(this.newKeyword)
        .then(response => {
          if (response.data) {
            response.data.map(r => {
              let isItem = this.searchItems.find(s => s.value === r.value)
              if (!isItem) {
                this.searchItems.push(r)
              }
            })
          }
          this.keywordLoading = false
        })
        .catch(error => {
          console.log(error);
          this.$emit('result', { success: false });
          this.keywordLoading = false
        });
      }, 500)
    },
    async removeKeyword(item) {
      if (item.tag) {
        this.keyword = this.keyword.filter(k => k !== item.tag)
        let kResp = await influencerAPIs.searchTopicKeyword(item.tag)
        if (kResp.data) {
          // remove match keywords
          let topicKeywords = kResp.data.map(r => r.tag)
          this.searchItems = this.searchItems.filter(s => topicKeywords.includes(s.tag))
        }
        if (this.keyword.length) {
          // if keyword still exists, push this keyword
          this.keyword.map(k => {
            let isNotExist = this.searchItems.find(s => s.tag !== k)
            if (isNotExist) {
              this.searchItems.push({
                tag: k,
                value: k
              })
            }
          })
        }
      }
      this.searchInf()
    },
    searchInfLookalike() {
      if (!this.newInfLookKeyword || this.newInfLookKeyword === null) {
        return
      }
      if (this.newInfLookKeyword.length < 2) {
        return
      }
      setTimeout(() => {
        this.lookLoading = true
        influencerAPIs
        .fetchLookalikeUsers(this.newInfLookKeyword)
        .then(response => {
          if (response.data) {
            response.data.data.map(r => {
              let isItem = this.infLookItems.find(s => s === r.username)
              if (!isItem) {
                this.infLookItems.push(r.username)
              }
            })
          }
          this.lookLoading = false
        })
        .catch(error => {
          console.log(error);
          this.$emit('result', { success: false });
          this.lookLoading = false
        });
      }, 500)
    },
    removeLookKeyword() {
      this.infLookKeyword = ''
    },
    searchAudLookalike() {
      if (!this.newAudLookKeyword || this.newAudLookKeyword === null) {
        return
      }
      if (this.newAudLookKeyword.length < 2) {
        return
      }
      setTimeout(() => {
        this.lookLoading = true
        influencerAPIs
        .fetchLookalikeUsers(this.newAudLookKeyword)
        .then(response => {
          if (response.data) {
            response.data.data.map(r => {
              let isItem = this.audLookItems.find(s => s === r.username)
              if (!isItem) {
                this.audLookItems.push(r.username)
              }
            })
          }
          this.lookLoading = false
        })
        .catch(error => {
          console.log(error);
          this.$emit('result', { success: false });
          this.audLookLoading = false
        });
      }, 500)
    },
    removeAudLookKeyword() {
      this.audLookKeyword = ''
    },
    getRandomColor: function() {
      // var letters = '0123456789ABCDEF';
      // var color = '#';
      // for (var i = 0; i < 6; i++) {
      //   color += letters[Math.floor(Math.random() * 16)];
      // }
      // return color;
      return '#947ded'
    },
    saveSettings(settings) {
      this.searchSettings = Object.assign([], settings)
      this.refreshWordCloud()
      if (!this.searchSettings.relevantKeywords) {
        this.isLocal = false
      }
    },
    async refreshWordCloud() {
      this.wordCloudData = []
      this.multipleKeywords = []
      let wordCount = 0
      let keywords = Object.assign([], this.keyword)
      for (let keyword of keywords) {
        let resp = await influencerAPIs.searchRelevantKeyword(keyword)
        if (!this.keyword.length) continue
        // relevant keyword percentage amount (30% of 60 keywords = 30 words)
        if (this.searchSettings.relevantKeywords > 0) {
          let respTotal = resp.data.length
          wordCount = Number(((this.searchSettings.relevantKeywords / 100) * respTotal).toFixed(0))
        }
        if (resp.data) {
          let results = []
          // let retIdx = 0
          // sort desc for distance
          sortBy(resp.data, ['distance'])
          resp.data.map((r, rIdx) => {
            // retIdx += 1
            // if (retIdx < 30) {
            //   results.push(r)
            // }
            results.push(r)
            // if word count less thans relevant keyword range from settings
            if (wordCount > 0 && rIdx < wordCount) {
              let tagName = r.tag.replace('#', '')
              if (!this.multipleKeywords.includes(tagName)) {
                this.multipleKeywords.push(tagName)
              }
            }
          })
          // add to wordcloud lists
          results.map(r => {
            let matchItem = this.wordCloudData.find(w => w[0] === r.tag.replace('#', ''))
            if (!matchItem) {
              this.wordCloudData.push([
                r.tag.replace('#', ''),
                Number(r.freq) * 100,
                10,
                'deg'
              ])
            }
          })
        }
      }
      this.searchInf()
    },
    upperCasePlatform(p) {
      if (p === 'instagram') {
        return 'Instagram'
      } else if (p === 'tiktok') {
        return 'TikTok'
      } else if (p === 'youtube') {
        return 'Youtube'
      }
    },
    setRouteParams() {
      // set Route Params from search Settings
      let routeParams = {
        platform: this.platformShort,
        topic: this.keyword.map(k => k).join(',')
      }
      if (this.searchSettings.relevantKeywords) {
        routeParams.relevantPercent = this.searchSettings.relevantKeywords
      }
      if (this.searchSettings.influencerGeos.length) {
        routeParams.influencerGeos = this.searchSettings.influencerGeos.join(',')
      }
      if (this.searchSettings.audGeos.length) {
        routeParams.audGeos = this.searchSettings.audGeos.join(',')
      }
      if (this.searchSettings.infGender) {
        routeParams.infGender = this.searchSettings.infGender
      }
      if (this.searchSettings.audGender) {
        routeParams.audGender = this.searchSettings.audGender
      }
      if (this.searchSettings.bio) {
        routeParams.bio = this.searchSettings.bio
      }
      if (this.searchSettings.keywords) {
        routeParams.keywords = this.searchSettings.keywords
      }
      if (this.searchSettings.mentions) {
        routeParams.mentions = this.searchSettings.mentions
      }
      if (this.searchSettings.hashtags) {
        routeParams.hashtags = this.searchSettings.hashtags
      }
      if (this.searchSettings.followers) {
        if (this.searchSettings.followers.from || this.searchSettings.followers.to) {
          routeParams.followers = [this.searchSettings.followers.from, this.searchSettings.followers.to].join(',')
        }
      }
      if (this.searchSettings.engagements) {
        if (this.searchSettings.engagements.from || this.searchSettings.engagements.to) {
          routeParams.engagements = [this.searchSettings.engagements.from, this.searchSettings.engagements.to].join(',')
        }
      }
      if (this.searchSettings.engagementRate.from) {
        routeParams.engagementRate = this.searchSettings.engagementRate.from
      }
      // if (this.isIqData) {
      //   routeParams.iqData = true
      // }
      this.$router.replace({ query: routeParams })
    },
    setSettingsFromRouteParams() {
      // assign to settings variable from route params on loaded
      if (this.$route.query.platform) {
        this.platform = this.upperCasePlatform(this.$route.query.platform)
      }
      if (this.$route.query.topic) {
        this.keyword = this.$route.query.topic.split(',')
        this.keyword.map(k => {
          this.searchItems.push({
            tag: k,
            value: k
          })
        })
      }
      if (this.$route.query.relevantPercent) {
        this.searchSettings.relevantKeywords = Number(this.$route.query.relevantPercent)
      }
      if (this.$route.query.influencerGeos) {
        this.searchSettings.influencerGeos = this.$route.query.influencerGeos.split(',')
      }
      if (this.$route.query.audGeos) {
        this.searchSettings.audGeos = this.$route.query.audGeos.split(',')
      }
      if (this.$route.query.infGender) {
        this.searchSettings.infGender = this.$route.query.infGender
      }
      if (this.$route.query.audGender) {
        this.searchSettings.audGender = this.$route.query.audGender
      }
      if (this.$route.query.followers) {
        let engRates = this.$route.query.followers.split(',')
        if (engRates.length > 1) {
          this.searchSettings.followers = {
            from: engRates[0],
            to: engRates[1]
          }
        }
      }
      if (this.$route.query.engagements) {
        let engRates = this.$route.query.engagements.split(',')
        if (engRates.length > 1) {
          this.searchSettings.engagements = {
            from: engRates[0],
            to: engRates[1]
          }
        }
      }
      if (this.$route.query.engagementRate) {
        this.searchSettings.engagementRate = {
          from: this.$route.query.engagementRate
        }
      }
      if (this.$route.query.bio) {
        this.searchSettings.bio = this.$route.query.bio
      }
      if (this.$route.query.keywords) {
        this.searchSettings.keywords = this.$route.query.keywords
      }
      if (this.$route.query.mentions) {
        this.searchSettings.mentions = this.$route.query.mentions
      }
      if (this.$route.query.hashtags) {
        this.searchSettings.hashtags = this.$route.query.hashtags
      }
      // if (this.$route.query.iqData) {
      //   this.isIqData = true
      // }
    },
    refreshReport(item) {
      this.overlayLoading = true
      let reportId = item.reportID;
      influencerAPIs.refreshAudienceReport(reportId).then(data => {
        this.overlayLoading = false
        this.paginate(this.currentPage)
      }).catch(err => {
        console.error(err);
        this.overlayLoading = false;
        this.$swal({
          title: 'Warning',
          text: 'We are updating data. Please try again in a few minutes',
          type: 'info'
        });
      });
    },
    async setProfilePics(picUrl) {
      for (let item of this.items) {
        try {
          await fetch(item.profilePicture)
        } catch (err) {
          // if img failed, set default img
          item.profilePicture = '/static/img/avatar/user.png'
          console.error(err)
        }
      }
    },
    openSettingsDialog() {
      this.dialog = true
    },
    async checkRemainInf() {
      /**
       * this will check for 30 infs limit from iqData search
       * if not available, alert and return false
       */
      let remainInf = 500 - Number(this.iqDataTotal)
      if (remainInf <= 0) {
        // influencer limit reached msg
        this.$swal({
          title: 'Limit Reached',
          text: 'IQData (30) Influencers Limit Reached',
          type: 'warning'
        })
        return false
      }
      // else if (this.iqDataTotal >= 10 && remainInf > 0) {
      //   // Check Next 10 Infs to search
      //   const result = await this.$swal({
      //     class: 'test',
      //     title: `${remainInf} Influencer Remains`,
      //     text: 'Are you sure to Unlock Next 10 Influencers',
      //     type: 'info',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Yes, Continue'
      //   });
      //   if (result.value) {
      //     return true
      //   } else return false
      // }
      return true
    },
    changeIQDataSwitch() {
      if (this.isLocal) {
        this.isIqData = false
        this.localPaginate()
      }
    },
    searchNextInf() {
      let newPage = this.currentPage + 1
      this.isIqData = true
      this.paginate(newPage)
    },
    changeNext() {
      // imple next step here
      this.$v.$touch()
      if (this.$v.searchSettings.$error) {
        return false
      }
      // if (!this.searchSettings.followers.to) {
      //   this.$swal({
      //     text: 'Please enter Followers Range To!',
      //     type: 'warning'
      //   });
      //   return
      // }
      this.step = 2
    },
    async exportExcel(page = 1) {
      // Export excel search creaters
      if (this.iqDataItems.length > 100) {
        this.$swal({
          text: 'Export Data cannot be more than 100 records!',
          type: 'warning'
        });
        return
      }
      this.overlayLoading = true
      influencerAPIs
        .downloadAudDataKeyword(this.payload(page), this.iqDataItems.length)
        .then(() => {
          this.overlayLoading = false
        })
        .catch(error => {
          this.overlayLoading = false
          console.log('error in downloading keyword search report', error);
        });
    }
  },
  created() {
    // Retrieve countries manually
    this.countries = countries
    this.countries = this.countries.map(c => c.name)
    this.setSettingsFromRouteParams()
  }
};
</script>

<style scoped>
.label-left {
  float: left;
  min-width: 160px;
  margin-right: 5px;
  font-size: 16px;
  font-weight: 600;
}
#ig-handle {
  cursor: pointer;
}
.engagement {
  color: #81bee2;
  font-size: 20px;
}
.summary {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 500px;
  margin: auto;
  margin-bottom: 15px;
  margin-top: 15px;
}

.summary td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.lbl-kobe {
  padding-top: 20px;
  padding-right: 9px;
  font-weight: normal !important;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
.hidden-text {
  text-shadow: 0 0 21px black;
  color: transparent;
  font: bold 16px Helvetica;
  padding-left: 12px;
}
</style>
<style>
.v-dialog-wrapper {
  margin-top: 24px !important;
  padding: 0px;
}
/* .topic-platform-select .v-input__slot {
  height: 68px;
} */
</style>



// WEBPACK FOOTER //
// index.vue?185a4c1c